import { render, staticRenderFns } from "./PageShare.vue?vue&type=template&id=aa698b38&scoped=true&"
import script from "./PageShare.vue?vue&type=script&lang=js&"
export * from "./PageShare.vue?vue&type=script&lang=js&"
import style0 from "./PageShare.vue?vue&type=style&index=0&id=aa698b38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa698b38",
  null
  
)

export default component.exports